import Polygon from '@arcgis/core/geometry/Polygon';
import Graphic from '@arcgis/core/Graphic';
import SimpleFillSymbol from '@arcgis/core/symbols/SimpleFillSymbol';
import * as turf from '@turf/turf';

import { FsMap } from '@lib/geo/map';

import { FsShapeStyles } from '../helpers';
import { ShapeStylesType } from '../types';
import { FsMapShape } from './shapes';

import SimpleFillSymbolProperties = __esri.SimpleFillSymbolProperties;

type ShapeOptions = {
  editable?: boolean;
  draggable?: boolean;
  clickable?: boolean;
};

export class FsMapRectangle extends FsMapShape {
  public shapeType = 'rectangle';

  constructor(public shape?: any) {
    super({
      shape,
    });
  }

  public createRectangle(
    bounds: any,
    style: ShapeStylesType,
    map: FsMap,
    options: ShapeOptions,
  ): FsMapRectangle {
    switch (this.defaultMapSource) {
      case 'google':
        const ne = { lat: bounds.north, lng: bounds.east };
        const sw = { lat: bounds.south, lng: bounds.west };
        const nw = { lat: bounds.north, lng: bounds.west };
        const se = { lat: bounds.south, lng: bounds.east };

        this.shape = new google.maps.Rectangle({
          bounds: new google.maps.LatLngBounds(sw, ne),
          ...style,
          ...options,
        });

        if (options.clickable) {
          this.listenForGoogleShapeEvents();
        }
        this.map = map;
        return this;
      case 'esri':
        const polygon = new Polygon({
          spatialReference: { wkid: 4326 },
          rings: [
            [
              [bounds.east, bounds.north],
              [bounds.east, bounds.south],
              [bounds.west, bounds.south],
              [bounds.west, bounds.north],
              [bounds.east, bounds.north],
            ],
          ],
        });

        const styles = new FsShapeStyles({ ...style })
          .styles as unknown as SimpleFillSymbolProperties;
        const simpleFill = new SimpleFillSymbol({
          ...styles,
        });

        this.shape = new Graphic({
          geometry: polygon,
          symbol: simpleFill,
          attributes: {
            id: crypto.randomUUID(),
          },
        });

        this.map = map;
        if (options.clickable) {
          this.setupEsriClickHandler();
        }
        return this;
    }
  }

  public getGeometry(): any {
    const bounds = this.getBounds();
    const paths = [
      [bounds.east, bounds.north],
      [bounds.west, bounds.north],
      [bounds.west, bounds.south],
      [bounds.east, bounds.south],
      [bounds.east, bounds.north],
    ];
    return turf.geometry('Polygon', [paths]);
  }
}
